import React, {useEffect, useState} from "react"
import {DroneTab} from "@murphy-frontend/common/api/DroneEvents/types"
import {FunctionComponent} from "react"
import {useNavigate} from "react-router-dom"
import TabPanel, {TabType} from "@murphy-frontend/web-core/components/Tabs/TabPanel"
import StartedEventFlowTab from "./StartedEventFlowTab"
import Button from "@murphy-frontend/web-core/components/Button"
import {useCompleteEvent} from "@murphy-frontend/common/api/DroneEvents/Mutations"
import {useCustomer} from "../../../common/contexts/CustomerContext"

interface StartedEventFlowTabsProps {
	tabs: DroneTab[]
	droneId: number
	isCompleted: boolean
}

const StartedEventFlowTabs: FunctionComponent<StartedEventFlowTabsProps> = ({tabs, droneId, isCompleted}) => {
	const [selectedTabId, setSelectedTabId] = useState<number>(0)
	const [completeText, setCompleteText] = useState("Close Incident")
	const onClickTab = (tabId: number) => {
		setSelectedTabId(tabId)
	}
	const navigate = useNavigate()

	const {customer} = useCustomer()

	const {mutate: completeEvent, isPending: completeEventIsPending} = useCompleteEvent(customer?.Id)

	useEffect(() => {
		const comp = tabs[tabs.length - 1].Components.find(_ => _.__Type === "CompletedButton")
		if (comp) setCompleteText(comp.Title)
	}, [tabs])

	const initialTabs: TabType[] = tabs.map((_, idx) => {
		return {
			id: idx,
			displayText: _.Title,
			customClass: "tab-transparent-panel-tab",
			customSelectedClass: "tab-transparent-default-panel-tab-selected wrap-text"
		}
	})

	const handleNext = () => {
		if (selectedTabId === tabs.length - 1) return
		else setSelectedTabId(selectedTabId + 1)
	}

	const handleBack = () => {
		if (selectedTabId === 0) return
		else setSelectedTabId(selectedTabId - 1)
	}

	const handleComplete = () => {
		completeEvent(droneId, {
			onSuccess: () => {
				navigate(`/startedeventflows/${droneId}/completed`)
			}
		})
	}

	return (
		<section className='card-container event-card-container'>
			<div className='event-progress-bar'>
				<div
					style={{
						backgroundColor: "#00A098",
						width: `${((selectedTabId + 1) / tabs.length) * 100}%`,
						height: "5px",
						borderTopLeftRadius: "4px",
						borderTopRightRadius: selectedTabId === tabs.length - 1 ? "4px" : 0
					}}
				/>
			</div>
			<div className='user-tab-wrapper'>
				<TabPanel
					tabs={initialTabs}
					onClickTab={onClickTab}
					selectedTabId={selectedTabId}
					customClass='tab-solid-panel-tms'
				/>
			</div>
			<StartedEventFlowTab tab={tabs.filter((_, idx) => idx === selectedTabId)[0]} />
			<div className='row field-add-user-btns'>
				<Button
					buttonStyle={"btn--outline"}
					isNeutralButton={true}
					buttonSize={"btn--medium"}
					onClick={handleBack}
					disabled={selectedTabId === 0}
				>
					Back
				</Button>
				{selectedTabId === tabs.length - 1 ? (
					<Button
						buttonSize={"btn--medium"}
						onClick={handleComplete}
						isLoading={completeEventIsPending}
						disabled={isCompleted}
					>
						{completeText}
					</Button>
				) : (
					<Button buttonSize={"btn--medium"} onClick={handleNext}>
						Next
					</Button>
				)}
			</div>
		</section>
	)
}

export default StartedEventFlowTabs
